import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import { OPUS_LOGO_PATH } from 'config';
import { useTranslation } from 'react-i18next';
import '../config/fonts';
import { opusQRPDFTemplateColors } from '../config/qr-pdf-template-colors';
import { createQRPDFTemplateStyles } from '../styles/qr-pdf-template-styles';
import { QRCodePDFTemplateProps } from '../types/template.types';
import { formatShiftDateTimeLines } from '../utils/format-shift-date-time-lines';

const styles = createQRPDFTemplateStyles(opusQRPDFTemplateColors);

export const OpusQRPDFTemplate = ({
  dataUrl,
  shiftName,
  location,
  startDate,
  endDate,
  startTime,
  endTime,
}: QRCodePDFTemplateProps) => {
  const { t } = useTranslation('web-common');

  const dateTimeLines = formatShiftDateTimeLines({ startDate, endDate, startTime, endTime });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image src={OPUS_LOGO_PATH} style={styles.logo} />
        </View>
        <View>
          <View style={styles.shiftDetailContainer}>
            <Text style={styles.shiftNameText}>{shiftName}</Text>
            <Text style={styles.shiftDetailText}>{location}</Text>
            {dateTimeLines.map((line) => (
              <Text key={line} style={styles.shiftDetailText}>
                {line}
              </Text>
            ))}
          </View>
          <View style={styles.infoTextContainer}>
            <Text style={styles.infoText}>{t('qr_code_pdf.check_in_greeting')}</Text>
            <Text style={styles.infoText}>{t('qr_code_pdf.scan_with_phone_camera')}</Text>
          </View>
          <View style={styles.qrCodeContainer}>
            <View style={styles.qrCodeBg}>
              <Image src={dataUrl} style={styles.qrImage} />
            </View>
          </View>
          <View style={styles.infoTextContainer}>
            <Text style={styles.infoText}>{t('qr_code_pdf.check_out_instruction')}</Text>
            <Text style={styles.infoText}>{t('qr_code_pdf.submit_hours_on_app')}</Text>
          </View>
        </View>
        <View style={styles.footer}></View>
      </Page>
    </Document>
  );
};
